module.exports = "/_next/static/images/4d78ce45941a56b13ce88412ab472e53-money-grow.svg";